module.exports = __webpack_public_path__ + "static/media/1017292.b68ee807.jpg";